"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EncounterOpenDraftOtherSchema () {
        return EncounterOpenDraftOtherSchema;
    },
    get EncounterOpenDraftResponseSchema () {
        return EncounterOpenDraftResponseSchema;
    },
    get OPEN_DRAFT_OTHERS_MAX_ITEMS () {
        return OPEN_DRAFT_OTHERS_MAX_ITEMS;
    }
});
const _zod = require("zod");
const OPEN_DRAFT_OTHERS_MAX_ITEMS = 10;
const EncounterOpenDraftOtherSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    providerName: _zod.z.string().min(1).max(200)
}).strict();
const EncounterOpenDraftResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid().nullable(),
    others: _zod.z.array(EncounterOpenDraftOtherSchema).max(OPEN_DRAFT_OTHERS_MAX_ITEMS)
}).strict();
